import { translateText } from '@alexis/helpers/translation';
import { Translations } from 'translations';

import PropositionItem from '@components/home/Propositions/PropositionItem';

import styles from './Propositions.module.scss';

type PropositionsProp = {
  translations: Translations;
  locale: string;
  countryName: string;
  isEgyptPOS?: boolean;
};

const Propositions: React.FC<PropositionsProp> = ({
  translations,
  locale,
  countryName,
  isEgyptPOS = false,
}) => {
  return (
    <div className={styles.propositions}>
      <PropositionItem
        title={translateText(translations.best_travel_deals, locale, countryName)}
        imageUrl={
          'https://zen.wego.com/cdn-cgi/image/format=auto/cms/images/travel-deals_348588186.png'
        }
      />

      <PropositionItem
        title={translations.flights_hotels_deals as string}
        imageUrl={
          'https://zen.wego.com/cdn-cgi/image/format=auto/cms/images/flight-hotel-deals_348588386.png'
        }
      />

      <PropositionItem
        title={translations.multiple_payment_methods as string}
        imageUrl={`https://zen.wego.com/cdn-cgi/image/format=auto/cms/images/${
          isEgyptPOS ? 'payment-method-egypt_348588474' : 'payment-method_348588357'
        }.png`}
      />

      <PropositionItem
        title={translations.customer_service_support as string}
        imageUrl={
          'https://zen.wego.com/cdn-cgi/image/format=auto/cms/images/customer-support_348588331.png'
        }
      />
    </div>
  );
};

export default Propositions;
